(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      if(document.getElementById('SortBy')){
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      }
      else{
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      document.getElementById('SortBy').value = event.target.dataset.value;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-ankauf-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.querySelector('#th-ankauf-form');
    if (!form || form.dataset.thInit === '1') return;
    form.dataset.thInit = '1';

    const wrap = form.closest('.th-ankauf__form-wrap');
    const workerUrl = (wrap && wrap.dataset.workerUrl) || '';
    const deviceSelect = form.querySelector('#th-ankauf-device');
    const otherWrap = form.querySelector('#th-ankauf-other-wrap');
    const otherInput = form.querySelector('#th-ankauf-other');
    const dropzone = form.querySelector('#th-ankauf-dropzone');
    const fileInput = form.querySelector('#th-ankauf-files');
    const filesList = form.querySelector('#th-ankauf-files-list');
    const submitBtn = form.querySelector('#th-ankauf-submit');
    const successBox = form.querySelector('#th-ankauf-success');
    const errorBox = form.querySelector('#th-ankauf-errors');
    const errorMsg = form.querySelector('#th-ankauf-error-message');
    const submitLabel = submitBtn.textContent.trim();

    const MAX_FILES = 5;
    const MAX_SIZE = 20 * 1024 * 1024;
    const ALLOWED_TYPES = new Set([
      'image/jpeg', 'image/png', 'application/pdf',
    ]);

    const files = [];
    let uploading = 0;

    const updateSubmitState = () => {
      submitBtn.disabled = uploading > 0;
      submitBtn.textContent = uploading > 0 ? 'Uploads laufen…' : submitLabel;
    };

    deviceSelect.addEventListener('change', () => {
      if (deviceSelect.value === 'Anderes Gerät') {
        otherWrap.classList.add('is-visible');
      } else {
        otherWrap.classList.remove('is-visible');
        if (otherInput) otherInput.value = '';
      }
    });

    const dropzoneError = form.querySelector('#th-ankauf-dropzone-error');
    let errorClearTimer = 0;
    const showDropzoneError = (msg) => {
      if (!dropzoneError) return;
      dropzoneError.textContent = msg;
      dropzoneError.hidden = false;
      if (errorClearTimer) clearTimeout(errorClearTimer);
      errorClearTimer = setTimeout(() => {
        dropzoneError.hidden = true;
        dropzoneError.textContent = '';
      }, 5000);
    };

    dropzone.addEventListener('click', () => fileInput.click());
    ['dragenter', 'dragover'].forEach((ev) => dropzone.addEventListener(ev, (e) => {
      e.preventDefault();
      dropzone.classList.add('is-dragover');
    }));
    ['dragleave', 'drop'].forEach((ev) => dropzone.addEventListener(ev, (e) => {
      e.preventDefault();
      dropzone.classList.remove('is-dragover');
    }));
    dropzone.addEventListener('drop', (e) => handleFiles(e.dataTransfer.files));
    fileInput.addEventListener('change', () => {
      handleFiles(fileInput.files);
      fileInput.value = '';
    });

    function handleFiles(fileList) {
      const remaining = MAX_FILES - files.length;
      if (remaining <= 0) {
        showDropzoneError('Maximal ' + MAX_FILES + ' Dateien erlaubt.');
        return;
      }
      const errors = [];
      Array.from(fileList).slice(0, remaining).forEach((file) => {
        if (file.size > MAX_SIZE) {
          errors.push(file.name + ': zu gross (max 20 MB)');
          return;
        }
        if (!ALLOWED_TYPES.has(file.type)) {
          errors.push(file.name + ': Dateityp nicht erlaubt');
          return;
        }
        addFile(file);
      });
      if (errors.length) showDropzoneError(errors.join(' · '));
    }

    function addFile(file) {
      const li = document.createElement('li');
      li.className = 'th-ankauf__file';

      const thumb = document.createElement('div');
      thumb.className = 'th-ankauf__file-thumb';
      if (file.type.startsWith('image/')) {
        const url = URL.createObjectURL(file);
        const img = document.createElement('img');
        img.className = 'th-ankauf__file-thumb';
        img.src = url;
        img.alt = '';
        img.addEventListener('load', () => URL.revokeObjectURL(url));
        li.appendChild(img);
      } else {
        thumb.textContent = 'PDF';
        thumb.style.cssText = 'display:flex;align-items:center;justify-content:center;font-size:.625rem;font-weight:700;';
        li.appendChild(thumb);
      }

      const meta = document.createElement('div');
      meta.className = 'th-ankauf__file-meta';
      const nameEl = document.createElement('span');
      nameEl.className = 'th-ankauf__file-name';
      nameEl.textContent = file.name;
      const statusEl = document.createElement('span');
      statusEl.className = 'th-ankauf__file-status';
      statusEl.textContent = 'Wird hochgeladen…';
      meta.append(nameEl, statusEl);
      li.appendChild(meta);

      const progress = document.createElement('div');
      progress.className = 'th-ankauf__file-progress';
      const progressBar = document.createElement('span');
      progress.appendChild(progressBar);
      li.appendChild(progress);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'th-ankauf__file-remove';
      remove.setAttribute('aria-label', 'Datei entfernen');
      remove.textContent = '×';
      li.appendChild(remove);

      const entry = { file, status: 'uploading', url: null, element: li, xhr: null };
      files.push(entry);

      remove.addEventListener('click', () => {
        if (entry.xhr) entry.xhr.abort();
        const idx = files.indexOf(entry);
        if (idx >= 0) files.splice(idx, 1);
        li.remove();
        updateSubmitState();
      });

      filesList.appendChild(li);

      if (!workerUrl) {
        entry.status = 'error';
        li.classList.add('th-ankauf__file--error');
        statusEl.textContent = 'Upload-Worker nicht konfiguriert';
        return;
      }
      uploadFile(entry, statusEl, progressBar);
    }

    function uploadFile(entry, statusEl, progressBar) {
      uploading++;
      updateSubmitState();

      const fd = new FormData();
      fd.append('file', entry.file);

      const xhr = new XMLHttpRequest();
      entry.xhr = xhr;
      xhr.open('POST', workerUrl.replace(/\/+$/, '') + '/upload?type=ankauf');
      xhr.responseType = 'json';

      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable) {
          const pct = Math.round((e.loaded / e.total) * 100);
          progressBar.style.width = pct + '%';
          statusEl.textContent = 'Wird hochgeladen… ' + pct + '%';
        }
      });

      xhr.addEventListener('load', () => {
        uploading = Math.max(0, uploading - 1);
        const res = xhr.response;
        if (xhr.status >= 200 && xhr.status < 300 && res && res.url) {
          entry.status = 'done';
          entry.url = res.url;
          entry.element.classList.add('th-ankauf__file--done');
          statusEl.textContent = 'Hochgeladen ✓';
          progressBar.style.width = '100%';
        } else {
          entry.status = 'error';
          entry.element.classList.add('th-ankauf__file--error');
          statusEl.textContent = 'Fehler: ' + ((res && res.error) || xhr.statusText || 'Upload fehlgeschlagen');
        }
        updateSubmitState();
      });

      xhr.addEventListener('error', () => {
        uploading = Math.max(0, uploading - 1);
        entry.status = 'error';
        entry.element.classList.add('th-ankauf__file--error');
        statusEl.textContent = 'Verbindungsfehler';
        updateSubmitState();
      });

      xhr.send(fd);
    }

    let submitting = false;

    const showError = (msg) => {
      successBox.hidden = true;
      errorMsg.textContent = msg;
      errorBox.hidden = false;
    };
    const showSuccess = () => {
      errorBox.hidden = true;
      successBox.hidden = false;
    };
    const hideMessages = () => {
      errorBox.hidden = true;
      successBox.hidden = true;
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (submitting) return;

      if (uploading > 0) {
        showError('Bitte warte, bis alle Uploads abgeschlossen sind.');
        return;
      }
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (!workerUrl) {
        showError('Upload-Worker nicht konfiguriert. Bitte kontaktiere uns direkt.');
        return;
      }

      const fields = {};
      const formData = new FormData(form);
      for (const [k, v] of formData.entries()) {
        if (typeof v === 'string' && v.trim()) {
          fields[k] = v.trim();
        }
      }

      // Turnstile-Token rausziehen (gehoert nicht in die Mail-Felder)
      const turnstileToken = fields['cf-turnstile-response'] || '';
      delete fields['cf-turnstile-response'];
      if (form.querySelector('.cf-turnstile') && !turnstileToken) {
        showError('Bitte bestätige im Sicherheitscheck, dass du kein Roboter bist.');
        return;
      }

      const photos = files
        .filter((f) => f.status === 'done' && f.url)
        .map((f) => f.url);

      submitting = true;
      hideMessages();
      submitBtn.disabled = true;
      submitBtn.textContent = 'Wird gesendet…';

      try {
        const res = await fetch(workerUrl.replace(/\/+$/, '') + '/submit?type=ankauf', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ fields, photos, turnstileToken }),
        });
        const data = await res.json().catch(() => ({}));
        if (res.ok && data.status === 'ok') {
          showSuccess();
          form.reset();
          files.splice(0).forEach((f) => f.element && f.element.remove());
          otherWrap.classList.remove('is-visible');
          successBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          showError(data.error || 'Versand fehlgeschlagen, bitte versuche es nochmal.');
        }
      } catch (err) {
        showError('Verbindungsfehler. Bitte prüfe deine Internetverbindung.');
      } finally {
        submitting = false;
        submitBtn.disabled = false;
        submitBtn.textContent = submitLabel;
        if (window.turnstile) { try { turnstile.reset(); } catch (e) {} }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-defekt-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.querySelector('#th-defekt-form');
    if (!form || form.dataset.thInit === '1') return;
    form.dataset.thInit = '1';

    const wrap = form.closest('.th-defekt__form-wrap');
    const workerUrl = (wrap && wrap.dataset.workerUrl) || '';
    const anliegenInputs = form.querySelectorAll('[name="Anliegen"]');
    const otherWrap = form.querySelector('#th-defekt-other-wrap');
    const otherInput = form.querySelector('#th-defekt-other');
    const dropzone = form.querySelector('#th-defekt-dropzone');
    const fileInput = form.querySelector('#th-defekt-files');
    const filesList = form.querySelector('#th-defekt-files-list');
    const submitBtn = form.querySelector('#th-defekt-submit');
    const successBox = form.querySelector('#th-defekt-success');
    const errorBox = form.querySelector('#th-defekt-errors');
    const errorMsg = form.querySelector('#th-defekt-error-message');
    const submitLabel = submitBtn.textContent.trim();

    const MAX_FILES = 5;
    const MAX_SIZE = 20 * 1024 * 1024;
    const ALLOWED_TYPES = new Set([
      'image/jpeg', 'image/png', 'application/pdf',
    ]);

    const files = [];
    let uploading = 0;
    let submitting = false;

    const updateSubmitState = () => {
      submitBtn.disabled = uploading > 0 || submitting;
      submitBtn.textContent = submitting
        ? 'Wird gesendet…'
        : uploading > 0
          ? 'Uploads laufen…'
          : submitLabel;
    };

    anliegenInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const selected = form.querySelector('[name="Anliegen"]:checked');
        if (selected && selected.value === 'Sonstiges') {
          otherWrap.classList.add('is-visible');
          otherInput.required = true;
        } else {
          otherWrap.classList.remove('is-visible');
          otherInput.required = false;
          otherInput.value = '';
        }
      });
    });

    const dropzoneError = form.querySelector('#th-defekt-dropzone-error');
    let errorClearTimer = 0;
    const showDropzoneError = (msg) => {
      if (!dropzoneError) return;
      dropzoneError.textContent = msg;
      dropzoneError.hidden = false;
      if (errorClearTimer) clearTimeout(errorClearTimer);
      errorClearTimer = setTimeout(() => {
        dropzoneError.hidden = true;
        dropzoneError.textContent = '';
      }, 5000);
    };

    dropzone.addEventListener('click', () => fileInput.click());
    ['dragenter', 'dragover'].forEach((ev) => dropzone.addEventListener(ev, (e) => {
      e.preventDefault();
      dropzone.classList.add('is-dragover');
    }));
    ['dragleave', 'drop'].forEach((ev) => dropzone.addEventListener(ev, (e) => {
      e.preventDefault();
      dropzone.classList.remove('is-dragover');
    }));
    dropzone.addEventListener('drop', (e) => handleFiles(e.dataTransfer.files));
    fileInput.addEventListener('change', () => {
      handleFiles(fileInput.files);
      fileInput.value = '';
    });

    function handleFiles(fileList) {
      const remaining = MAX_FILES - files.length;
      if (remaining <= 0) {
        showDropzoneError('Maximal ' + MAX_FILES + ' Dateien erlaubt.');
        return;
      }
      const errors = [];
      Array.from(fileList).slice(0, remaining).forEach((file) => {
        if (file.size > MAX_SIZE) {
          errors.push(file.name + ': zu gross (max 20 MB)');
          return;
        }
        if (!ALLOWED_TYPES.has(file.type)) {
          errors.push(file.name + ': Dateityp nicht erlaubt');
          return;
        }
        addFile(file);
      });
      if (errors.length) showDropzoneError(errors.join(' · '));
    }

    function addFile(file) {
      const li = document.createElement('li');
      li.className = 'th-defekt__file';

      if (file.type.startsWith('image/')) {
        const url = URL.createObjectURL(file);
        const img = document.createElement('img');
        img.className = 'th-defekt__file-thumb';
        img.src = url;
        img.alt = '';
        img.addEventListener('load', () => URL.revokeObjectURL(url));
        li.appendChild(img);
      } else {
        const thumb = document.createElement('div');
        thumb.className = 'th-defekt__file-thumb';
        thumb.textContent = 'PDF';
        thumb.style.cssText = 'display:flex;align-items:center;justify-content:center;font-size:.625rem;font-weight:700;';
        li.appendChild(thumb);
      }

      const meta = document.createElement('div');
      meta.className = 'th-defekt__file-meta';
      const nameEl = document.createElement('span');
      nameEl.className = 'th-defekt__file-name';
      nameEl.textContent = file.name;
      const statusEl = document.createElement('span');
      statusEl.className = 'th-defekt__file-status';
      statusEl.textContent = 'Wird hochgeladen…';
      meta.append(nameEl, statusEl);
      li.appendChild(meta);

      const progress = document.createElement('div');
      progress.className = 'th-defekt__file-progress';
      const progressBar = document.createElement('span');
      progress.appendChild(progressBar);
      li.appendChild(progress);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'th-defekt__file-remove';
      remove.setAttribute('aria-label', 'Datei entfernen');
      remove.textContent = '×';
      li.appendChild(remove);

      const entry = { file, status: 'uploading', url: null, element: li, xhr: null };
      files.push(entry);

      remove.addEventListener('click', () => {
        if (entry.xhr) entry.xhr.abort();
        const idx = files.indexOf(entry);
        if (idx >= 0) files.splice(idx, 1);
        li.remove();
        updateSubmitState();
      });

      filesList.appendChild(li);

      if (!workerUrl) {
        entry.status = 'error';
        li.classList.add('th-defekt__file--error');
        statusEl.textContent = 'Upload-Worker nicht konfiguriert';
        return;
      }
      uploadFile(entry, statusEl, progressBar);
    }

    function uploadFile(entry, statusEl, progressBar) {
      uploading++;
      updateSubmitState();

      const fd = new FormData();
      fd.append('file', entry.file);

      const xhr = new XMLHttpRequest();
      entry.xhr = xhr;
      xhr.open('POST', workerUrl.replace(/\/+$/, '') + '/upload?type=defekt');
      xhr.responseType = 'json';

      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable) {
          const pct = Math.round((e.loaded / e.total) * 100);
          progressBar.style.width = pct + '%';
          statusEl.textContent = 'Wird hochgeladen… ' + pct + '%';
        }
      });

      xhr.addEventListener('load', () => {
        uploading = Math.max(0, uploading - 1);
        const res = xhr.response;
        if (xhr.status >= 200 && xhr.status < 300 && res && res.url) {
          entry.status = 'done';
          entry.url = res.url;
          entry.element.classList.add('th-defekt__file--done');
          statusEl.textContent = 'Hochgeladen ✓';
          progressBar.style.width = '100%';
        } else {
          entry.status = 'error';
          entry.element.classList.add('th-defekt__file--error');
          statusEl.textContent = 'Fehler: ' + ((res && res.error) || xhr.statusText || 'Upload fehlgeschlagen');
        }
        updateSubmitState();
      });

      xhr.addEventListener('error', () => {
        uploading = Math.max(0, uploading - 1);
        entry.status = 'error';
        entry.element.classList.add('th-defekt__file--error');
        statusEl.textContent = 'Verbindungsfehler';
        updateSubmitState();
      });

      xhr.send(fd);
    }

    const showError = (msg) => {
      successBox.hidden = true;
      errorMsg.textContent = msg;
      errorBox.hidden = false;
    };
    const showSuccess = () => {
      errorBox.hidden = true;
      successBox.hidden = false;
    };
    const hideMessages = () => {
      errorBox.hidden = true;
      successBox.hidden = true;
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (submitting) return;
      if (uploading > 0) {
        showError('Bitte warte, bis alle Uploads abgeschlossen sind.');
        return;
      }
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (!workerUrl) {
        showError('Upload-Worker nicht konfiguriert. Bitte kontaktiere uns direkt.');
        return;
      }

      const fields = {};
      const formData = new FormData(form);
      for (const [k, v] of formData.entries()) {
        if (typeof v === 'string' && v.trim()) {
          fields[k] = v.trim();
        }
      }

      // Turnstile-Token rausziehen (gehoert nicht in die Mail-Felder)
      const turnstileToken = fields['cf-turnstile-response'] || '';
      delete fields['cf-turnstile-response'];
      if (form.querySelector('.cf-turnstile') && !turnstileToken) {
        showError('Bitte bestätige im Sicherheitscheck, dass du kein Roboter bist.');
        return;
      }

      const plz = fields.PLZ || '';
      const ort = fields.Ort || '';
      if (plz || ort) {
        fields['PLZ-Ort'] = (plz + ' ' + ort).trim();
        delete fields.PLZ;
        delete fields.Ort;
      }

      const photos = files
        .filter((f) => f.status === 'done' && f.url)
        .map((f) => f.url);

      submitting = true;
      hideMessages();
      updateSubmitState();

      try {
        const res = await fetch(workerUrl.replace(/\/+$/, '') + '/submit?type=defekt', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ fields, photos, turnstileToken }),
        });
        const data = await res.json().catch(() => ({}));
        if (res.ok && data.status === 'ok') {
          showSuccess();
          form.reset();
          files.splice(0).forEach((f) => f.element && f.element.remove());
          otherWrap.classList.remove('is-visible');
          successBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          showError(data.error || 'Versand fehlgeschlagen, bitte versuche es nochmal.');
        }
      } catch (err) {
        showError('Verbindungsfehler. Bitte prüfe deine Internetverbindung.');
      } finally {
        submitting = false;
        updateSubmitState();
        if (window.turnstile) { try { turnstile.reset(); } catch (e) {} }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.th-faq-section').forEach(function (section) {
      var input = section.querySelector('.th-faq__search-input');
      if (!input) return;
      var list = section.querySelector('.th-faq__list');
      var items = list.querySelectorAll('.th-faq__item');
      var groups = list.querySelectorAll('.th-faq__group');
      var noResults = list.querySelector('.th-faq__no-results');

      function normalize(str) {
        return (str || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[̀-ͯ]/g, '');
      }

      function update() {
        var raw = input.value.trim();
        var term = normalize(raw);
        var anyVisible = false;

        items.forEach(function (item) {
          if (!term) {
            item.hidden = false;
            anyVisible = true;
            return;
          }
          var q = normalize(item.getAttribute('data-th-faq-question') || '');
          var a = normalize(item.querySelector('.th-faq__answer').textContent);
          var match = q.indexOf(term) !== -1 || a.indexOf(term) !== -1;
          item.hidden = !match;
          if (!match) item.removeAttribute('open');
          if (match) anyVisible = true;
        });

        groups.forEach(function (group) {
          var hasVisible = Array.prototype.some.call(
            group.querySelectorAll('.th-faq__item'),
            function (i) { return !i.hidden; }
          );
          group.hidden = !hasVisible;
          var title = group.previousElementSibling;
          if (title && title.classList.contains('th-faq__group-title')) {
            title.hidden = !hasVisible;
          }
        });

        if (noResults) noResults.hidden = !term || anyVisible;
      }

      input.addEventListener('input', update);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.th-reviews-section');
    sections.forEach((section) => {
      if (section.dataset.thInit === '1') return;
      section.dataset.thInit = '1';

      const track = section.querySelector('[id^="th-reviews-track-"]');
      const prev = section.querySelector('[id^="th-reviews-prev-"]');
      const next = section.querySelector('[id^="th-reviews-next-"]');
      const dotsWrap = section.querySelector('[id^="th-reviews-dots-"]');
      if (!track || !prev || !next || !dotsWrap) return;

      const slides = Array.from(track.querySelectorAll('.th-reviews__slide'));
      if (slides.length === 0) return;

      const slidesPerView = () => {
        const w = window.innerWidth;
        if (w < 600) return 1;
        if (w < 1000) return 2;
        return 3;
      };

      const pageCount = () => Math.max(1, Math.ceil(slides.length / slidesPerView()));

      const buildDots = () => {
        dotsWrap.innerHTML = '';
        const count = pageCount();
        for (let i = 0; i < count; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'th-reviews__dot';
          dot.setAttribute('aria-label', 'Gehe zu Seite ' + (i + 1));
          dot.addEventListener('click', () => goTo(i));
          dotsWrap.appendChild(dot);
        }
        updateDots();
      };

      const currentPage = () => {
        const sw = track.clientWidth;
        const sl = track.scrollLeft;
        const perView = slidesPerView();
        if (slides.length === 0) return 0;
        const slideWidth = sw / perView;
        return Math.round(sl / (slideWidth * perView));
      };

      const updateDots = () => {
        const dots = dotsWrap.querySelectorAll('.th-reviews__dot');
        const cur = currentPage();
        dots.forEach((d, i) => d.setAttribute('aria-current', i === cur ? 'true' : 'false'));
        const total = pageCount();
        prev.disabled = cur <= 0;
        next.disabled = cur >= total - 1;
      };

      const goTo = (page) => {
        const perView = slidesPerView();
        const target = slides[page * perView];
        if (target) {
          track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        }
      };

      prev.addEventListener('click', () => goTo(Math.max(0, currentPage() - 1)));
      next.addEventListener('click', () => goTo(Math.min(pageCount() - 1, currentPage() + 1)));

      let rafId = 0;
      track.addEventListener('scroll', () => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = 0;
          updateDots();
        });
      }, { passive: true });

      window.addEventListener('resize', () => {
        buildDots();
      });

      buildDots();

      const autoplay = section.dataset.autoplay === 'true';
      const autoplayInterval = parseInt(section.dataset.autoplayInterval || '5000', 10);
      const motionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
      const pauseBtn = section.querySelector('[id^="th-reviews-pause-"]');
      const playIcon = pauseBtn && pauseBtn.querySelector('.th-reviews__pause-icon-play');
      const pauseIcon = pauseBtn && pauseBtn.querySelector('.th-reviews__pause-icon-pause');
      const pauseLabel = pauseBtn && pauseBtn.querySelector('.th-reviews__pause-label');
      let timer = null;
      let userPaused = false;
      const stopTimer = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };
      const startTimer = () => {
        stopTimer();
        if (!autoplay) return;
        if (motionMedia.matches) return;
        if (userPaused) return;
        if (slides.length <= slidesPerView()) return;
        timer = setInterval(() => {
          const cur = currentPage();
          const total = pageCount();
          goTo(cur >= total - 1 ? 0 : cur + 1);
        }, autoplayInterval);
      };

      const updatePauseUI = () => {
        if (!pauseBtn) return;
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        const label = userPaused ? 'Auto-Slider fortsetzen' : 'Auto-Slider pausieren';
        pauseBtn.setAttribute('aria-label', label);
        if (pauseLabel) pauseLabel.textContent = label;
        if (playIcon && pauseIcon) {
          playIcon.hidden = !userPaused;
          pauseIcon.hidden = userPaused;
        }
      };

      if (pauseBtn) {
        pauseBtn.addEventListener('click', () => {
          userPaused = !userPaused;
          updatePauseUI();
          if (userPaused) stopTimer();
          else startTimer();
        });
        updatePauseUI();
      }

      startTimer();
      section.addEventListener('mouseenter', stopTimer);
      section.addEventListener('mouseleave', () => { if (!userPaused) startTimer(); });
      motionMedia.addEventListener('change', startTimer);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopTimer();
        else if (!userPaused) startTimer();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
